<template>
    <modal v-bind:show.sync="show" ref="modal" size="medium">
        <div slot="header"></div>

        <form-wizard
            v-cloak
            v-bind:validation="validators"
            v-bind:action="actionUrl"
        >
            <wizard-step
                v-bind:next-label="trans('Next: Description')"
                v-on:enter="elementFocus('name')"
            >
                <div class="row">
                    <div class="column">
                        <h4 class="add-product-heading f-s-7 m-b-2">{{ trans('Give your membership a name') }}</h4>
                    </div>
                </div>
                <div class="row">
                    <div class="small-12 columns">
                        <div v-bind:class="{'has-error': errors.has('name')}" class="form-group">
                            <input v-model="name" class="input__field" type="text" ref="name" name="name" v-bind:placeholder="trans('Membership name')" maxlength="255" required>
                        </div>
                        <div v-if="errors.has('name')" class="form-help">{{ errors.get('name') }}</div>
                    </div>
                </div>
            </wizard-step>
            <wizard-step
                v-bind:prev-label="trans('Back to Membership Name')"
                v-bind:next-label="trans('Create Membership')"
                v-on:enter="elementFocus('description')"
            >
                <div class="row">
                    <div class="column">
                        <h4 class="add-product-heading f-s-7 m-b-2">{{ trans('Describe your membership') }}</h4>
                        <p class="f-s-4 c-medium-tint m-b-6">{{ trans("Don't worry you can change this later") }}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="small-12 columns">
                        <div v-bind:class="{'has-error': errors.has('description')}" class="form-group form-group-simple hl-txt">
                            <textarea v-model="description" class="m-t-1 input__field" ref="description" rows="2" v-bind:placeholder="trans('Start by typing your description here...')" name="description"></textarea>
                        </div>
                        <div v-if="errors.has('description')" class="form-help">{{ errors.get('description') }}</div>
                    </div>
                </div>
            </wizard-step>
        </form-wizard>

        <div slot="footer"></div>
    </modal>
</template>
<script>
import { EventBus } from '../../event-bus.js';
import Errors from '../../errors.js';
import Modal from '../modals/Modal.vue';

export default {
    components: {
        Modal,
    },
    data() {
        return {
            show: false,
            errors: new Errors(),
            validators: {
                1: this.validateName,
                2: this.validateDescription,
            },
            name: null,
            description: null,
            actionUrl: window.Kourses.activeBaseUrl + '/memberships',
        }
    },
    methods: {
        validateName() {
            this.errors.clear();

            if ( ! this.name || this.name.trim().length === 0) {
                this.errors.set('name', this.trans('Please enter a name for your membership'));

                return false;
            }

            return true;
        },
        validateDescription() {
            this.errors.clear();

            if ( ! this.description || this.description.trim().length === 0) {
                this.errors.set('description', this.trans('Please enter a short description for your membership'));

                return false;
            }

            return true;
        },
        elementFocus(element) {
            this.$nextTick(() => this.$refs[element].focus());
        },
    },
    created() {
        let $vm = this;

        EventBus.$on('modal:new-membership', () => {
            $vm.show = true;
        });
    },
    mounted() {
        // Auto-open (show) modal window if hash is what we want
        if (window.location.hash && window.location.hash.substring(1) === 'new-membership') {
            this.show = true;
        }
    },
}
</script>